// src/com/tsr/TransPlanTsrGroup.js
import React, { useState } from 'react';
//import { styled } from '@mui/material/styles';
import { AppBar, Tabs, Tab, Slide, Dialog, DialogContent, DialogActions } from '@mui/material';
import { TopCode } from '../../value/AppConst';
import { useReactiveVar } from '@apollo/client';
import { transPlanTsrItemRepo } from '../../value/AppModel';
import TransPlanTsrViewSupplyGen982 from './TransPlanTsrViewSupplyGen982';
import TransPlanTsrViewSupplyFresh from './TransPlanTsrViewSupplyFresh';
import TransPlanTsrViewSupplyExpress from './TransPlanTsrViewSupplyExpress';
import TransPlanTsrViewSupplyGeneral from './TransPlanTsrViewSupplyGeneral';
import TransPlanTsrViewBulkDetail from './TransPlanTsrViewBulkDetail';
import TransPlanTsrViewDetail from './TransPlanTsrViewDetail';
import { DialogHeader } from '../../common/TopStyle';

export const TabCodeForTsrEditorGroup = {
    DetailEditor: 1,
    SupplyEditor: 2,
    BulkEditor: 3,
};

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

/**
 * 3종류의 뷰어를 Tab으로 구성한 뷰어 그룹
 * 1. 상차 상세 내역
 * 2. 물류 집기 - 상온, 냉장, Express 각각 서로 다른 구성.
 * 3. Bulk 상차 상세내역 (특정 DC만 사용)
 * @param {*} param0 
 */
export default function TransPlanTsrGroup({
    open,
    onClose,
    onCompleteTakingOverCargo,
}) {
    const item = useReactiveVar(transPlanTsrItemRepo);
    const [tabNow, setTabNow] = useState(TabCodeForTsrEditorGroup.DetailEditor);


    const renderByTab = () => {
        if(tabNow===TabCodeForTsrEditorGroup.SupplyEditor) {
            if(item.dcCd===TopCode.DcCode.Adc982) {
                return <TransPlanTsrViewSupplyGen982/>;
            }
            if(item.dcTypeCd===TopCode.DcTypeCode.Fresh) {
                return <TransPlanTsrViewSupplyFresh />;
            }
            if(item.dcTypeCd===TopCode.DcTypeCode.Express) {
                return <TransPlanTsrViewSupplyExpress />;
            }
            return <TransPlanTsrViewSupplyGeneral />;
        }
        if(tabNow===TabCodeForTsrEditorGroup.BulkEditor) {
            return <TransPlanTsrViewBulkDetail />;
        }
        // default 상차 상세내역
        return <TransPlanTsrViewDetail onCompleteTakingOverCargo={onCompleteTakingOverCargo} />;
    };

    const onClickClose = () => {
        onClose();
    };

    return(
        <Dialog
            fullScreen
            open={open}
            onClose={onClose}
            slots={{transition: Transition}}
        >
            <DialogHeader
                title={"TSR 발행 상세 조회: " + (item ? item.vehPlates : '')}
                onClickClose={onClickClose}
            />
            <DialogContent style={{paddingTop: '0.5rem', }}>
                {renderByTab()}
            </DialogContent>
            <DialogActions>
                <AppBar position="static" color="default" style={{borderTop: '1px solid #ddd'}}
                >
                    <Tabs value={tabNow} onChange={(e, v)=>setTabNow(v)}>
                        <Tab value={TabCodeForTsrEditorGroup.DetailEditor} label="상차 상세내역" />
                        <Tab value={TabCodeForTsrEditorGroup.SupplyEditor} label="물류 집기" />
                        {
                            item.dcCd===TopCode.DcCode.Adc982 &&
                            <Tab value={TabCodeForTsrEditorGroup.BulkEditor} label="Bulk 상차 상세내역" />
                        }
                    </Tabs>
                </AppBar>

            </DialogActions>
        </Dialog>
    );
}

/*


    return(
        <Dialog
            fullScreen
            open={open}
            onClose={onClose}
            slots={{transition: Transition}}
        >
            <DialogTitle
                style={{
                    backgroundColor: AppStyle.SecondaryRGB, color: 'white', fontWeight: 'bold',
                    display: 'flex', alignItems: 'center'
                }}
            >
                <span style={{flexGrow:1}}>TSR 발행 상세 조회</span>
                <IconButton onClick={onClickClose}>
                    <CloseIcon style={{color: 'white'}}/>
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <AppBar position="static" color="default"
                    style={{marginBottom: '0.5rem', }}
                >
                    <Tabs value={tabNow} onChange={(e, v)=>setTabNow(v)}>
                        <Tab value={TabCodeForTsrEditorGroup.DetailEditor} label="상차 상세내역" />
                        <Tab value={TabCodeForTsrEditorGroup.SupplyEditor} label="물류 집기" />
                        {
                            item.dcCd===TopCode.DcCode.Adc982 &&
                            <Tab value={TabCodeForTsrEditorGroup.BulkEditor} label="Bulk 상차 상세내역" />
                        }
                    </Tabs>
                </AppBar>
                {renderByTab()}
            </DialogContent>
        </Dialog>
    );



*/